var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeedHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_312",
    "data-name": "Rectangle 312",
    width: 24,
    height: 24,
    transform: "translate(297 142)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_62",
    "data-name": "Mask Group 62",
    transform: "translate(-297 -142)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5965",
    "data-name": "Group 5965",
    transform: "translate(300 145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5964",
    "data-name": "Group 5964"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M0,9.563V8.438c.01-.051.023-.1.03-.153.061-.411.1-.826.184-1.231A9,9,0,0,1,7.432.139C7.766.085,8.1.046,8.438,0H9.563c.045.01.09.021.135.029a13.541,13.541,0,0,1,1.689.3,8.855,8.855,0,0,1,6.474,7.12c.067.325.093.659.139.988V9.563a1.038,1.038,0,0,0-.029.136,8.794,8.794,0,0,1-2.179,5.2,8.815,8.815,0,0,1-5.242,2.964c-.327.058-.658.092-.988.136H8.438a.744.744,0,0,0-.117-.028,8.68,8.68,0,0,1-4.269-1.458A8.865,8.865,0,0,1,.14,10.568C.078,10.236.046,9.9,0,9.563m1.259-.577A7.74,7.74,0,1,0,9.019,1.259,7.744,7.744,0,0,0,1.259,8.986"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M142.024,95.64a3.374,3.374,0,0,1,1.48.291,1.825,1.825,0,0,1,.868,2.635,3.8,3.8,0,0,1-1,1.142c-.1.081-.2.163-.295.249a1.284,1.284,0,0,0-.431.947c0,.111,0,.223-.006.334a.423.423,0,0,1-.318.432.8.8,0,0,1-.136.034c-.653.1-.879-.083-.893-.741a2.205,2.205,0,0,1,.888-1.911,3.844,3.844,0,0,0,.551-.462,1.8,1.8,0,0,0,.367-.583.71.71,0,0,0-.442-.912,1.339,1.339,0,0,0-1.683.48.624.624,0,0,1-1.025.1.69.69,0,0,1-.132-.723,1.754,1.754,0,0,1,1.071-1.089,2.879,2.879,0,0,1,1.134-.227",
    transform: "translate(-133.221 -91.157)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M168.988,243.889a.9.9,0,1,1-1.8.021.9.9,0,1,1,1.8-.021",
    transform: "translate(-159.346 -231.595)",
    fill: "#0a64f9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedHelp);
export default __webpack_public_path__ + "static/media/need_help.3267a86092d6e8194cdead85ebd05319.svg";
export { ForwardRef as ReactComponent };